import React, { useEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';

import { useNavigate } from "react-router-dom";
import { routes } from '../../MainPage';
import LazyLoad from 'react-lazyload';
import { useDispatch, useSelector } from 'react-redux';
import { CommonApiFun } from '../../Redux/Action/index'
function Banner(props) {
    const navigate = useNavigate()
    SwiperCore.use([Autoplay])
    const dispatch = useDispatch()
    var eventArr = useSelector((state) => state.eventArr)

    useEffect(() => {
        var data = { action: "event" }
        dispatch(CommonApiFun("api/Api_controller/post", JSON.stringify(data))).then((res) => {

            dispatch({ type: 'EVENT_DATA', payload: res.data })

        }).catch((e) => {

        })
    }, [])
    var bannerArr = [
        {
            Heading: 'Dr. Samuel Hahnemann',
            discription: <p><span><i class="fas fa-quote-left"></i></span>The physician high and only mission is to restore the sick to health, to cure, as it is termed.<span><i class="fas fa-quote-right"></i></span> - organon of medicine.</p>,
            Image: require('../../img/banner_xs_1.png')
        },
        {
            Heading: 'Dr. Stuart Close',
            discription: <p>
                <span><i class="fas fa-quote-left"></i></span>The practical demonstrations of homoeopathy is committed to its personal representative, whose success will be proportionate to their efficiency.<span><i class="fas fa-quote-right"></i></span>
            </p>,
            Image: require('../../img/banner_xs_2.png')
        },
        {
            Heading: 'Dr. J T Kent',
            discription: <p>
                <span><i class="fas fa-quote-left"></i></span>Will and the understanding, constitute man; conjoined they make life and activity, they manufacture the body and cause all things of the body.<span><i class="fas fa-quote-right"></i></span>
            </p>,
            Image: require('../../img/banner_xs_3.png')
        },
        {
            Heading: 'Be optimist with homeopathy',
            discription: <>
                <p>
                    <span><i class="fas fa-quote-left"></i></span>Eternal energy can bring you from dark side to devine light.<span><i class="fas fa-quote-right"></i></span>
                </p>
                <a
                    href={routes.makeAppointmnet}
                    className="btn"
                    onClick={() => navigate(routes.makeAppointmnet)}
                >
                    Make Appointment
                </a>
            </>,
            Image: require('../../img/banner_xs_4.png')
        },
        {
            Heading: 'Dr. Jayesh Ghadiya',
            discription: <>
                <p >
                    <span><i class="fas fa-quote-left"></i></span> Consult homoeopath and take the first step toward the acknowledgement of yourself.<span><i class="fas fa-quote-right"></i></span>

                </p>
                <a
                    href={routes.team + "/jayesh-ghadiya"}
                    className="btn"
                    onClick={() => navigate(routes.team + "/jayesh-ghadiya")}
                >
                    View Profile
                </a>
            </>,
            Image: require('../../img/banner_xs_5.png')
        },
        {
            Heading: "Nutrition and Wellness",
            discription: <a
                href={routes.NutritionAndWellness}
                className="btn"
                onClick={() => navigate(routes.NutritionAndWellness)}
            >
                Read More

            </a>,
            Image: require('../../img/banner_xs_6.png')
        },
       {
            // Heading: "Our Specialities",
            discription: (
                <div className="feature-list">
                    <div className="feature-item">
                        <h4>Genius Brain</h4>
                        <p>Unlock your mental potential.</p>
                    </div>

                    <div className="feature-item">
                        <h4>Women's Care</h4>
                        <p>Empowering your daily wellness.</p>
                    </div>

                    <div className="feature-item">
                        <h4>Integrated Growth</h4>
                        <p>Fueling your natural progress.</p>
                    </div>
                </div>
            ),
            Image: require("../../img/banner_xs_7.png")
        }

    ]
    var SwiperSlideArr = [];
    bannerArr.map((item, index) => {
        SwiperSlideArr.push(
            <SwiperSlide className="swiper-slide  shopSliderItem">
                <div class="slideshow-text" >
                    <div class="container" >
                        <div class="row">
                            <div class="slideshow-content" >
                                <h1>{item.Heading}</h1>
                                {item.discription}
                            </div>
                            <div class="slideshow-img">
                                <img src={item.Image}
                                    alt={"banner_xs" + (index + 1)} />
                            </div>
                        </div>
                    </div>
                </div>
            </SwiperSlide>
        )
    })
    return (
        <div className="web-sect shopSliderBox">
            <Swiper
                modules={[Navigation, Pagination,]}
                className="shopSlider"
                spaceBetween={0}
                slidesPerView={1}
                effect={"fade"}
                autoHeight={true}
                pagination={{
                    //el: ".swiper-pagination",
                    clickable: true,
                }}
                autoplay={{ delay: 8000, }}
                allowTouchMove={true}
            >
                {SwiperSlideArr}
                {eventArr.length != 0 && eventArr[0].banner_image != "" &&
                    <SwiperSlide className="swiper-slide  shopSliderItem">
                        <div class="slideshow-text" >
                            <div class="container" >
                                <div class="row">
                                    <div class="slideshow-content" >
                                        <h1>{eventArr[0].title}</h1>

                                        <a
                                            //href={routes.team + "/jayesh-ghadiya"}
                                            className="btn"
                                          //  onClick={() => navigate(routes.team + "/jayesh-ghadiya")}
                                             onClick={()=>{navigate(routes.event+"/info",{state:eventArr[0]})}}
                                           // onClick={()=>{alert("fsdkfh")}}
                                        >
                                            View Profile
                                        </a>
                                    </div>
                                    <div class="slideshow-img">
                                        <img src={eventArr[0].banner_image}
                                            alt={"banner_xs_event"} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                }
                <div className="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets"></div>
            </Swiper>
        </div>
    );
}

export default Banner;